<template>
  <div>
    <div class="ui secondary pointing top attached tabular menu three item">
      <a class="item active" v-on:click="getRPDs(currentPageRPD, level)" data-tab="rpd_umu">Рабочие программы дисциплин</a>
      <a class="item" v-on:click="getRPPs(currentPageRPP, level)" data-tab="rpp_umu">Рабочие программы практик</a>
      <a class="item" v-on:click="getRPGs" data-tab="rpg_umu">Рабочие программы Научных иследований</a>
    </div>
    <div class="ui bottom attached tab segment active" data-tab="rpd_umu">
        <div class="ui secondary three item menu">
            <a class="item active"
               @click="level=1, getRPDs(currentPageRPD, level)"
            >
                ВО
            </a>
            <a class="item"
               @click="level=2, getRPDs(currentPageRPD, level)"
            >
                Аспирантура
            </a>
            <a class="item"
               @click="level=3, getRPDs(currentPageRPD, level)"
            >
                СПО
            </a>
        </div>
      <div class="ui styled fluid accordion" >
        <div v-for="prog in rpd">
          <div class="title">
            <tr>
              <td width="1%">
                <i class="dropdown icon"></i>
              </td>
              <td width="35%">
                {{ prog.main_info.discipline }}
              </td>
              <td width="35%">
                {{ prog.main_info.speciality }}
              </td>
              <td width="15%">
                {{ prog.main_info.creator.fio }}
              </td>
              <td width="6%">
                <a v-bind:href="'/programms/rpd/' + prog.id">Ссылка</a>
              </td>
            </tr>
          </div>
          <div class="content">
            <tr>
              <td width="15%"><h4>Отправленно на согласование</h4></td>
              <td width="10%">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
              <td width="25%">
                <h4>
                  Отправлено {{prog.umu_agreed_times}} раз
                </h4>
              </td>
            </tr>
            <div class="ui fitted divider"></div>
            <div class="ui form">
              <div id="basis">
                <div class="inline fields">
                  <div class="five wide field">
                    <div class="ui right pointing large label">
                      РАБОЧАЯ ПРОГРАММА
                    </div>
                    <input type="text" placeholder="Дисциплина" v-model="prog.main_info.discipline" disabled="true">
                  </div>
                  <div class="seven wide field" v-if="prog.main_info.quality !== 'Специалитет'">
                    <div class="ui right pointing large label">
                      Направление подготовки
                    </div>
                    <input type="text" placeholder="Специальность" v-model="prog.main_info.speciality" disabled="true">
                  </div>
                  <div class="seven wide field" v-if="prog.main_info.quality === 'Специалитет'">
                    <div class="ui right pointing large label">
                      Специальность
                    </div>
                    <input type="text" placeholder="Специальность" v-model="prog.main_info.speciality" disabled="true">
                  </div>
                  <div class="four wide field">
                    <div class="ui right pointing large label">
                      Квалификация выпускника
                    </div>
                    <input type="text" placeholder="Квалификация" v-model="prog.main_info.quality" disabled="true">
                  </div>
                </div>
                <div class="inline fields">
                  <div class="seven wide field" v-if="prog.main_info.quality !== 'Специалитет'">
                    <div class="ui right pointing large label">
                      Профиль
                    </div>
                    <input type="text" placeholder="Профиль" v-model="prog.main_info.profile" disabled="true">
                  </div>
                  <div class="seven wide field" v-if="prog.main_info.quality === 'Специалитет'">
                    <div class="ui right pointing large label">
                      Специализация
                    </div>
                    <input type="text" placeholder="Профиль" v-model="prog.main_info.profile" disabled="true">
                  </div>
                  <div class="three wide field">
                    <div class="ui right pointing large label">
                      Год набора
                    </div>
                    <input type="text" placeholder="Год набора" v-model="prog.main_info.year" disabled="true">
                  </div>
                  <div class="three wide field">
                    <div class="ui right pointing large label">
                      Форма обучения
                    </div>
                    <input type="text" placeholder="Форма обучения" v-model="prog.main_info.edu_form" disabled="true">
                  </div>
                </div>
                <div class="ui equal width form">
                  <div class="inline fields">
                    <div class="inline fields" v-if="prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7">
                      <div class="three wide field">
                        <div class="ui right pointing large label">
                          Курс
                        </div>
                        <input type="text" placeholder="Курс" v-model="prog.main_info.course" disabled="true">
                      </div>
                      <div class="three wide field">
                        <div class="ui right pointing large label">
                          Семестр
                        </div>
                        <input type="text" placeholder="Семестр" v-model="prog.main_info.period" disabled="true">
                      </div>
                    </div>
                    <div class="three wide field" v-else>
                      <div class="ui right pointing large label">
                        Год обучения
                      </div>
                      <input type="text" placeholder="Курс" v-model="prog.main_info.period" disabled="true">
                    </div>
                    <div class="three wide field" v-if="prog.main_info.credit.length">
                      <div class="ui right pointing large label">
                        Зачет
                      </div>
                      <input type="text" placeholder="Зачет" v-model="prog.main_info.credit" disabled="true">
                    </div>
                    <div class="three wide field" v-if="prog.main_info.credit_mark.length">
                      <div class="ui right pointing large label">
                        Зачет с оценкой
                      </div>
                      <input type="text" placeholder="Зачет" v-model="prog.main_info.credit_mark" disabled="true">
                    </div>
                    <div class="three wide field" v-if="prog.main_info.exam.length">
                      <div class="ui right pointing large label">
                        Экзамен
                      </div>
                      <input type="text" placeholder="Экзамен" v-model="prog.main_info.exam" disabled="true">
                    </div>
                  </div>
                  <div class="inline fields">
                    <div class="four wide field">
                      <div class="ui right pointing large label">
                        Трудоемкость
                      </div>
                      <input type="text" placeholder="Трудоемкость" v-model="prog.main_info.load.hour" disabled="true">
                    </div>
                    <div class="three wide field">
                      <div class="ui right pointing large label">
                        ЗЕТ
                      </div>
                      <input type="text" placeholder="ЗЕТ" v-model="prog.main_info.load.zet" disabled="true">
                    </div>
                  </div>
                  <div v-if="prog.main_info.speciality_code.split('.')[1] === '02'">
                    <div class="two fields">
                      <div class="seven wide field">
                        <div class="ui right pointing large label">
                          Вид дисциплины
                        </div>
                        <input type="text" placeholder="Вид дисциплины" v-model="prog.main_info.discipline_type" disabled="true">
                      </div>
                      <div class="four wide field">
                        <div class="ui right pointing large label">
                          Индекс дисциплины
                        </div>
                        <input type="text" placeholder="Индекс" v-model="prog.main_info.disciplines_index" disabled="true">
                      </div>
                    </div>
                  </div>
                  <div class="inline fields">
                    <div class="four wide field">
                      <div class="ui right pointing large label">
                        И.О.Фамилия
                      </div>
                      <input type="text" placeholder="И.О.Фамилия" v-model="prog.main_info.creator.fio" disabled="true">
                    </div>
                    <div class="four wide field">
                      <div class="ui right pointing large label">
                        Должность
                      </div>
                      <input type="text" placeholder="Должность" v-model="prog.main_info.creator.position" disabled="true">
                    </div>
                    <div class="four wide field">
                      <div class="ui right pointing large label">
                        Ученая степень
                      </div>
                      <input type="text" placeholder="Ученая степень" v-model="prog.main_info.creator.title" disabled="true">
                    </div>
                  </div>
                </div>
                <div class="two fields">
                  <div class="six wide field">
                    <label>Выпускающая кафедра</label>
                    <div class="ui input">
                      <input type="text" placeholder="Выпускающая кафедра" v-model="prog.main_info.grad_dep" disabled="true">
                    </div>
                  </div>
                  <div class="six wide field">
                    <label>Заведующий выпускающей кафедры</label>
                    <div class="ui input">
                      <input type="text" placeholder="Заведующий выпускающей кафедры" v-model="prog.main_info.provisor" disabled="true">
                    </div>
                  </div>
                </div>
                <div class="inline fields">
                  <div class="five wide field">
                    <div class="ui right pointing large label">
                      Факультет
                    </div>
                    <input type="text" placeholder="Факультет" v-model="prog.main_info.facility" disabled="true">
                  </div>
                  <div class="five wide field">
                    <div class="ui right pointing large label">
                      Обеспечивающая Кафедра
                    </div>
                    <input type="text" placeholder="Обеспечивающая кафедра" v-model="prog.main_info.department" disabled="true">
                  </div>
                  <div class="five wide field">
                    <div class="ui right pointing large label">
                      Заведующий кафедрой
                    </div>
                    <input type="text" placeholder="Заведующий кафедрой" v-model="prog.main_info.dep_manager" disabled="true">
                  </div>
                </div>
                <div class="two fields">
                  <div class="four wide field">
                    <label>Дата заседания кафедры</label>
                    <div class="ui input">
                      <input type="text" placeholder="Дата заседания кафедры" v-model="prog.main_info.approval_date" disabled="true">
                    </div>
                  </div>
                  <div class="two wide field">
                    <label>Протокол №</label>
                    <div class="ui input">
                      <input type="text" placeholder="Протокол №" v-model="prog.main_info.protocol_num" disabled="true">
                    </div>
                  </div>
                </div>
                <div><textarea rows="2" v-model="prog.main_info.basis" disabled="true"></textarea></div>
                <div class="two fields">
                  <div class="four wide field">
                    <label>Дата утверждения приказа</label>
                    <div class="ui input">
                      <input type="text" placeholder="Дата утверждения приказа" v-model="prog.main_info.basis_date"  disabled="true">
                    </div>
                  </div>
                  <div class="two wide field">
                    <label>№ Приказа</label>
                    <div class="ui input">
                      <input type="text" placeholder="№ Приказа" v-model="prog.main_info.basis_num" disabled="true">
                    </div>
                  </div>
                </div>
              </div>
              <div id="1.Цели">
                <div v-if="prog.main_info.speciality_code.split('.')[1] === '02'" >
                  <h3 class="ui dividing header">1. ОБЛАСТЬ ПРИМЕНЕНИЯ ПРОГРАММЫ</h3>
                  <h3 class="ui dividing header">1. ОБЛАСТЬ ПРИМЕНЕНИЯ ПРОГРАММЫ</h3>
                  <h4>Рабочая программа {{prog.main_info.discipline}} являетсяч частью ППССЗ в соотвествии с ФГОС по специальности {{prog.main_info.speciality}}</h4>
                  <h4>Дисциплина требует предварительного изучения</h4>
                  <span v-html="prog.purpose_old"></span>
                  <h4>Дисциплина предшествует изучению (предназначена для создания теоретической базы знаний у студентов для изучения)</h4>
                  <span v-html="prog.tasks_old"></span>
                </div>
                <div v-else>
                  <h3 class="ui dividing header">1. ЦЕЛИ И ЗАДАЧИ ОСВОЕНИЯ ДИСЦИПЛИНЫ</h3>
                  <div>
                    <h4>1.1 Цель дисциплины</h4>
                    <span v-html="prog.purpose_old"></span>
                    <h4>1.2 Задачи дисциплины</h4>
                    <span v-html="prog.tasks_old"></span>
                  </div>
                </div>
              </div>
              <div id="2.Место дисциплины">
                <h3 class="ui dividing header">2. МЕСТО ДИСЦИПЛИНЫ В СТРУКТУРЕ ОБРАЗОВАТЕЛЬНОЙ ПРОГРАММЫ</h3>
                <span v-if="prog.main_info.speciality_code.split('.')[1] !== '02'" v-html="prog.discipline_place_old"></span>
                <div v-if="prog.main_info.speciality_code.split('.')[1] === '02'" >
                  <h4>Воспитание реализуется в программе в единстве урочной и внеурочной деятельности. В рамках каждого занятия планируются воспитательные цели, направленные на формирование профессионала в соответствии с квалификацией {{prog.main_info.quality}} и воспитание соответствующих качеств личности.</h4>
                  <h4>При планировании и проведении занятий планируются активные и интерактивные формы учебной деятельности:</h4>
                  <ul>
                    <li v-if="prog.spo_comp.business">Деловые игры</li>
                    <li v-if="prog.spo_comp.role">Ролевые игры</li>
                    <li v-if="prog.spo_comp.situation">Разбор ситуаций</li>
                    <li v-if="prog.spo_comp.computer">Компьютерные симуляции</li>
                  </ul>
                  <h4>Дисциплина реализуется с использованием технологии электронного обучения. Дистанционные образовательные технологии могут быть использованы для всех видов занятий при необходимости (погодные условия, санитарноэпидемиологические требования, режим чрезвычайной ситуации, военные действия и т.д.)</h4>
                </div>
              </div>
              <div id="3. Компетенции">
                <h3 v-if="prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7" class="ui dividing header">3. КОМПЕТЕНЦИИ ОБУЧАЮЩЕГОСЯ, ФОРМИРУЕМЫЕ В РЕЗУЛЬТАТЕ ОСВОЕНИЯ ДИСЦИПЛИНЫ (МОДУЛЯ) И ИНДИКАТОРЫ ИХ ДОСТИЖЕНИЯ</h3>
                <div v-if="prog.main_info.speciality_code.split('.')[1] === '02'">
                  <div v-if="prog.main_info.discipline_type === 'Профессиональная дисциплина' || prog.main_info.discipline_type === 'МДК' || prog.main_info.discipline_type === 'Профессиональный модуль' || prog.main_info.discipline_type === 'Учебная практика' || prog.main_info.discipline_type === 'Производственная практика'">
                    <h4>3.1 Общие компетенции</h4>
                    <table class="ui basic celled table">
                      <thead>
                      <tr class="active">
                        <th width="20%"><div class="headTable">Код</div></th>
                        <th width="30%"><div class="headTable">Наименование общей компетенции</div></th>
                        <th width="50%"><div class="headTable">Наименование индикатора достижения общей компетенции</div></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for = "comp in prog.competition.UK">
                        <td> {{ comp.info.code }}</td>
                        <td>{{ comp.info.desc}}</td>
                        <td v-html="comp.info.text"></td>
                      </tr>
                      </tbody>
                    </table>
                    <h4>3.2 Професиональные компетенции и индикаторы их достижения</h4>
                    <table class="ui basic celled table" v-if="prog.competition.OPK_cat.length">
                      <thead>
                      <tr class="active">
                        <th width="20%"><div class="headTable">Код</div></th>
                        <th width="30%"><div class="headTable">Наименование профессиональной компетенции</div></th>
                        <th width="50%"><div class="headTable">Наименование индикатора достижения профессиональной компетенции</div></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for = "comp in prog.competition.OPK_cat">
                        <td> {{ comp.info.code }}</td>
                        <td>{{ comp.info.desc }}</td>
                        <td v-html="comp.text"></td>
                      </tr>
                      </tbody>
                    </table>
                    <table class="ui basic celled table" v-if="!prog.competition.OPK_cat.length">
                      <thead>
                      <tr class="active">
                        <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
                        <th width="60%" colspan="2"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for = "comp in prog.competition.OPK">
                        <td>{{comp.name}}</td>
                        <td v-html="comp.text"></td>
                      </tr>
                      </tbody>
                    </table>
                    <h5 class="ui dividing header">Уметь </h5>
                    <span v-html="prog.spo_comp.able"></span>
                    <h5 class="ui dividing header">Знать </h5>
                    <span v-html="prog.spo_comp.know"></span>
                    <h5 v-if="prog.main_info.discipline_type ==='МДК' || prog.main_info.discipline_type === 'Профессиональный модуль' || prog.main_info.discipline_type === 'Учебная практика' || prog.main_info.discipline_type === 'Производственная практика'" class="ui dividing header">Иметь практическое применение </h5>
                    <span v-if="prog.main_info.discipline_type ==='МДК' || prog.main_info.discipline_type === 'Профессиональный модуль' || prog.main_info.discipline_type === 'Учебная практика' || prog.main_info.discipline_type === 'Производственная практика'" v-html="prog.spo_comp.own"></span>
                  </div>
                  <div v-if="prog.main_info.discipline_type === 'Общеобразовательная дисциплина'">
                    <span v-html="prog.spo_comp.general"></span>
                  </div>
                </div>
                <div v-else-if="prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7" >
                  <h4>3.1 Универсальные компетенции и индикаторы их достижения</h4>
                  <table class="ui basic celled table">
                    <thead>
                    <tr class="active">
                      <th width="20%"><div class="headTable">Категория (группа) универсальных компетенций</div></th>
                      <th width="40%"><div class="headTable">Код и наименование универсальной компетенции</div></th>
                      <th width="40%"><div class="headTable">Код и наименование индикатора достижения универсальной компетенции</div></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for = "comp in prog.competition.UK">
                      <td>{{comp.info.cat}}</td>
                      <td>
                        {{ comp.info.code }} {{ comp.info.desc }}
                      </td>
                      <td v-html="comp.text"></td>
                    </tr>
                    </tbody>
                  </table>
                  <h4>3.2 Общепрофессиональные компетенции и индикаторы их достижения</h4>
                  <table class="ui basic celled table" v-if="prog.competition.OPK_cat.length">
                    <thead>
                    <tr class="active">
                      <th width="20%"><div class="headTable">Категория (группа) общепрофессиональных компетенций</div></th>
                      <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
                      <th width="40%"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for = "comp in prog.competition.OPK_cat">
                      <td>{{comp.info.cat}}</td>
                      <td>
                        {{ comp.info.code }} {{ comp.info.desc }}
                      </td>
                      <td v-html="comp.text"></td>
                    </tr>
                    </tbody>
                  </table>
                  <table class="ui basic celled table" v-if="!prog.competition.OPK_cat.length">
                    <thead>
                    <tr class="active">
                      <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
                      <th width="60%"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for = "comp in prog.competition.OPK">
                      <td>{{comp.name}}</td>
                      <td v-html="comp.text"></td>
                    </tr>
                    </tbody>
                  </table>
                  <h4>3.3 Профессиональные компетенции и индикаторы их достижения</h4>
                  <table class="ui basic celled table">
                    <thead>
                    <tr class="active">
                      <th width="40%"><div class="headTable">Код и наименование профессиональной компетенции</div></th>
                      <th width="60%"><div class="headTable">Код и наименование индикатора достижения профессиональной компетенции</div></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for = "comp in prog.competition.PK">
                      <td>{{comp.name}}</td>
                      <td v-html="comp.text"></td>
                    </tr>
                    </tbody>
                  </table>
                  <h4>3.4 Дополнительные профессиональные компетенции</h4>
                  <table class="ui basic celled table">
                    <thead>
                    <tr class="active">
                      <th width="40%"><div class="headTable">Код и наименование дополнительной профессиональной компетенции</div></th>
                      <th width="60%"><div class="headTable">Код и наименование индикатора достижения дополнительной профессиональной компетенции</div></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for = "comp in prog.competition.DPK">
                      <td>{{comp.name}}</td>
                      <td v-html="comp.text"></td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <h3 class="ui dividing header">4. СТРУКТУРА ДИСЦИПЛИНЫ (МОДУЛЯ)</h3>
              <div>
                Общая трудоемкость дисциплины составляет {{prog.main_info.load.zet}} зачетных единиц, {{ prog.main_info.load.hour}} академических часов
              </div>
              <div id="7. Образовательные технологии">
                <h3 class="ui dividing header">7. ОБРАЗОВАТЕЛЬНЫЕ ТЕХНОЛОГИИ</h3>
                <span v-html="prog.edu_tech_old"></span>
<!--                <table class="ui basic celled table" v-if="prog.main_info.speciality_code.split('.')[1] === '02'">-->
<!--                  <thead>-->
<!--                  <tr class="active">-->
<!--                    <th width="28%"><div class="headTable">Формы/Методы</div></th>-->
<!--                    <th width="40%"><div class="headTable">лекционные занятия</div></th>-->
<!--                    <th width="42%"><div class="headTable">практические/лабораторные/семинарские занятия</div></th>-->
<!--                  </tr>-->
<!--                  </thead>-->
<!--                  <tbody>-->
<!--                  <tr v-for = "form in prog.forms">-->
<!--                    <td>{{ form.name }}</td>-->
<!--                    <td>{{ form.lec }}</td>-->
<!--                    <td>{{ form.prac }}</td>-->
<!--                  </tr>-->
<!--                  </tbody>-->
<!--                </table>-->
              </div>
              <div id="8. Оценочные средства">
                <h3 class="ui dividing header">8. ОЦЕНОЧНЫЕ СРЕДСТВА ДЛЯ ПРОМЕЖУТОЧНОЙ АТТЕСТАЦИИ</h3>
                <table class="ui basic celled table" v-if="prog.main_info.speciality_code.split('.')[1] === '02' && (prog.main_info.discipline_type === 'Профессиональная дисциплина' || prog.main_info.discipline_type === 'МДК' || prog.main_info.discipline_type === 'Профессиональный модуль' || prog.main_info.discipline_type === 'Учебная практика' || prog.main_info.discipline_type === 'Производственная практика')">
                  <thead>
                  <tr class="active">
                    <th width="40%"><div class="headTable">Результаты (освоенные профессиональные компетенции)</div></th>
                    <th width="60%"><div class="headTable">Формы и методы контроля и оценки</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "option in prog.competition.UK">
                    <td>{{ option.info.code }} {{ option.info.desc }}</td>
                    <td>{{ option.control }}</td>
                  </tr>
                  <tr v-for = "option in prog.competition.OPK_cat">
                    <td>{{ option.info.code }} {{ option.info.desc }}</td>
                    <td>{{ option.control }}</td>
                  </tr>
                  </tbody>
                </table>
                <table class="ui basic celled table" v-else-if="prog.main_info.speciality_code.split('.')[1] === '02' && prog.main_info.discipline_type === 'Общеобразовательная дисциплина'">
                  <thead>
                  <tr class="active">
                    <th width="60%"><div class="headTable">Результаты (освоенные профессиональные компетенции)</div></th>
                    <th width="40%" colspan="2"><div class="headTable">Формы и методы контроля и оценки</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "control in prog.spo_controls">
                    <td>{{ control.name }}</td>
                    <td>{{ control.lec }}</td>
                  </tr>
                  </tbody>
                </table>
                <span v-html="prog.eval_tool_old"></span>
              </div>
              <div id="9. Учебно-методическое обеспечение">
                <h3 class="ui dividing header">9. УЧЕБНО-МЕТОДИЧЕСКОЕ И ИНФОРМАЦИОННОЕ ОБЕСПЕЧЕНИЕ</h3>
                <div>
                  <h4>9.a) литература</h4>
                  <span v-html="prog.literature_old"></span>
                  <h4>9.б) программное обеспечение и Интернет ресурсы</h4>
                  <table class="ui basic celled table">
                    <thead>
                    <tr class="active">
                      <th width="20%"><div class="headTable">Наименование</div></th>
                      <th width="40%"><div class="headTable">Описание</div></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for = "soft in prog.software">
                      <td>
                        {{soft.info.name}}
                      </td>
                      <td>
                        {{ soft.info.license }}
                      </td>
                    </tr>
                    <tr v-for = "res in prog.resources">
                      <td>{{res.name}}</td>
                      <td>{{res.desc}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <h4>9.в) профессиональные базы данных и информационные справочные системы</h4>
                  <table class="ui basic celled table">
                    <thead>
                    <tr class="active">
                      <th width="20%"><div class="headTable">Наименование</div></th>
                      <th width="40%"><div class="headTable">Описание</div></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for = "db in prog.data_bases">
                      <td>{{db.name}}</td>
                      <td>{{db.desc}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="10. МТО">
                <h3 class="ui dividing header">10. МАТЕРИАЛЬНО-ТЕХНИЧЕСКОЕ ОБЕСПЕЧЕНИЕ ДИСЦИПЛИНЫ</h3>
                <span v-html="prog.structure_text_old"></span>
              </div>
              <div class="ui fitted divider"></div>
              <div>
                <button class="ui button negative" v-on:click="denyRPD(prog.id, rpd.indexOf(prog), prog.umu_agreed_times, prog.umu_comment)">
                  Отклонить
                </button>
                <button class="ui right floated button positive" v-on:click="agreedRPD(prog.id, rpd.indexOf(prog))">
                  Согласовать
                </button>
                <button class="ui right floated button blue" v-on:click="showRPD(prog.id)">
                  <i v-if="((prog.main_info.speciality_code === '13.03.01' || (prog.main_info.speciality_code === '13.03.02' && prog.main_info.profile === 'Электроэнергетика')) && (prog.main_info.discipline !== 'Спортивные игры' && prog.main_info.discipline !== 'Общая физическая подготовка' && prog.main_info.discipline !== 'Легкая атлетика') || (prog.main_info.speciality_code === '21.05.02' || prog.main_info.speciality_code === '40.03.01') && (prog.main_info.discipline !== 'Python. Анализ данных' && prog.main_info.discipline !== 'Компьютерная графика') || (prog.main_info.speciality_code === '38.05.01' || prog.main_info.speciality_code === '20.03.01') && (prog.main_info.discipline !== 'Спортивные игры' && prog.main_info.discipline !== 'Общая физическая подготовка' && prog.main_info.discipline !== 'Легкая атлетика' && prog.main_info.discipline !== 'Python. Анализ данных' && prog.main_info.discipline !== 'Компьютерная графика') || prog.main_info.speciality_code === '44.03.02' || prog.main_info.speciality_code === '38.05.02') && prog.has_z_part === false && prog.main_info.edu_form === 'Очная'" class="big pencil alternate icon" style="color: red"></i>
                  <i v-if="(prog.main_info.speciality_code === '13.03.01' || (prog.main_info.speciality_code === '13.03.02' && prog.main_info.profile === 'Электроэнергетика') || prog.main_info.speciality_code === '21.05.02' || prog.main_info.speciality_code === '20.03.01' || prog.main_info.speciality_code === '40.03.01' || prog.main_info.speciality_code === '44.03.02' || prog.main_info.speciality_code === '38.05.01' || prog.main_info.speciality_code === '38.05.02') && prog.has_z_part === true && prog.main_info.edu_form === 'Очная'" class="big pencil alternate icon" style="color: green"></i>
                  Просмотр
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="rpp_umu">
      <div class="ui secondary three item menu">
        <a class="item active"
           @click="level=1, getRPPs(currentPageRPP, level)"
        >
            ВО
        </a>
        <a class="item"
           @click="level=2, getRPPs(currentPageRPP, level)"
        >
            Аспирантура
        </a>
        <a class="item"
           @click="level=3, getRPPs(currentPageRPP, level)"
        >
            СПО
        </a>
      </div>
      <div class="ui styled fluid accordion" >
        <div v-for="prog in rpp">
          <div class="title">
            <tr>
              <td width="1%">
                <i class="dropdown icon"></i>
              </td>
              <td width="35%">
                {{ prog.main_info.discipline }}
              </td>
              <td width="35%">
                {{ prog.main_info.speciality }}
              </td>
              <td width="15%">
                {{ prog.main_info.creator.fio }}
              </td>
              <td width="8%">
                {{ prog.main_info.year }}
              </td>
              <td width="6%">
                <a v-bind:href="'/programms/rpp/' + prog.id">Ссылка</a>
              </td>
            </tr>
          </div>
          <div class="content">
            <tr>
              <td width="15%"><h4>Отправленно на согласование</h4></td>
              <td width="10%">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
              <td width="25%">
                <h4>
                  Отправлено {{prog.umu_agreed_times}} раз
                </h4>
              </td>
            </tr>
            <div class="ui fitted divider"></div>
            <div class="ui form">
              <div class="inline fields">
                <div class="five wide field">
                  <div class="ui right pointing large label">
                    РАБОЧАЯ ПРОГРАММА
                  </div>
                  <input type="text" placeholder="Дисциплина" v-model="prog.main_info.discipline" disabled="true">
                </div>
                <div class="seven wide field" v-if="prog.main_info.speciality_code.split('.')[1] !== '05'">
                  <div class="ui right pointing large label">
                    Направление подготовки
                  </div>
                  <input type="text" placeholder="Специальность" v-model="prog.main_info.speciality" disabled="true">
                </div>
                <div class="seven wide field" v-if="prog.main_info.speciality_code.split('.')[1] === '05'">
                  <div class="ui right pointing large label">
                    Специальность
                  </div>
                  <input type="text" placeholder="Специальность" v-model="prog.main_info.speciality" disabled="true">
                </div>
                <div class="four wide field">
                  <div class="ui right pointing large label">
                    Квалификация выпускника
                  </div>
                  <input type="text" placeholder="Квалификация" v-model="prog.main_info.quality" disabled="true">
                </div>
              </div>
              <div class="inline fields">
                <div class="seven wide field" v-if="prog.main_info.speciality_code.split('.')[1] !== '05'">
                  <div class="ui right pointing large label">
                    Профиль
                  </div>
                  <input type="text" placeholder="Профиль" v-model="prog.main_info.profile" disabled="true">
                </div>
                <div class="seven wide field" v-if="prog.main_info.speciality_code.split('.')[1] === '05'">
                  <div class="ui right pointing large label">
                    Специализация
                  </div>
                  <input type="text" placeholder="Профиль" v-model="prog.main_info.profile" disabled="true">
                </div>
                <div class="two wide field">
                  <div class="ui right pointing large label">
                    Год набора
                  </div>
                  <input type="text" placeholder="Год набора" v-model="prog.main_info.year" disabled="true">
                </div>
                <div class="three wide field">
                  <div class="ui right pointing large label">
                    Форма обучения
                  </div>
                  <input type="text" placeholder="Форма обучения" v-model="prog.main_info.edu_form" disabled="true">
                </div>
              </div>
              <div class="ui equal width form">
                <div class="inline fields">
                  <div class="inline fields" v-if="prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7">
                    <div class="three wide field">
                      <div class="ui right pointing large label">
                        Курс
                      </div>
                      <input type="text" placeholder="Курс" v-model="prog.main_info.course" disabled="true">
                    </div>
                    <div class="three wide field">
                      <div class="ui right pointing large label">
                        Семестр
                      </div>
                      <input type="text" placeholder="Семестр" v-model="prog.main_info.period" disabled="true">
                    </div>
                  </div>
                  <div class="three wide field" v-else>
                    <div class="ui right pointing large label">
                      Год обучения
                    </div>
                    <input type="text" placeholder="Курс" v-model="prog.main_info.period" disabled="true">
                  </div>
                  <div class="three wide field" v-if="prog.main_info.credit_mark.length">
                    <div class="ui right pointing large label">
                      Зачет с оценкой
                    </div>
                    <input type="text" placeholder="Зачет" v-model="prog.main_info.credit_mark" disabled="true">
                  </div>
                  <div class="three wide field">
                    <div class="ui right pointing large label">
                      Трудоемкость
                    </div>
                    <input type="text" placeholder="Трудоемкость" v-model="prog.main_info.load.hour" disabled="true">
                  </div>
                  <div class="three wide field">
                    <div class="ui right pointing large label">
                      ЗЕТ
                    </div>
                    <input type="text" placeholder="ЗЕТ" v-model="prog.main_info.load.zet" disabled="true">
                  </div>
                </div>
                <div v-if="prog.main_info.speciality_code.split('.')[1] === '02'">
                  <div class="two fields">
                    <div class="seven wide field">
                      <div class="ui right pointing large label">
                        Вид дисциплины
                      </div>
                      <input type="text" placeholder="Вид дисциплины" v-model="prog.main_info.discipline_type" disabled="true">
                    </div>
                    <div class="four wide field">
                      <div class="ui right pointing large label">
                        Индекс дисциплины
                      </div>
                      <input type="text" placeholder="Индекс" v-model="prog.main_info.disciplines_index" disabled="true">
                    </div>
                  </div>
                </div>
                <div class="inline fields">
                  <div class="four wide field">
                    <div class="ui right pointing large label">
                      И.О.Фамилия
                    </div>
                    <input type="text" placeholder="И.О.Фамилия" v-model="prog.main_info.creator.fio" disabled="true">
                  </div>
                  <div class="four wide field">
                    <div class="ui right pointing large label">
                      Должность
                    </div>
                    <input type="text" placeholder="Должность" v-model="prog.main_info.creator.position" disabled="true">
                  </div>
                  <div class="four wide field">
                    <div class="ui right pointing large label">
                      Ученая степень
                    </div>
                    <input type="text" placeholder="Ученая степень" v-model="prog.main_info.creator.title" disabled="true">
                  </div>
                </div>
              </div>
              <div class="two fields">
                <div class="six wide field">
                  <label>Выпускающая кафедра</label>
                  <div class="ui input">
                    <input type="text" placeholder="Выпускающая кафедра" v-model="prog.main_info.grad_dep" disabled="true">
                  </div>
                </div>
                <div class="six wide field">
                  <label>Заведующий выпускающей кафедры</label>
                  <div class="ui input">
                    <input type="text" placeholder="Заведующий выпускающей кафедры" v-model="prog.main_info.provisor" disabled="true">
                  </div>
                </div>
              </div>
              <div class="three fields">
                <div class="five wide field">
                  <label>Факультет</label>
                  <div class="ui input">
                    <input type="text" placeholder="Факультет" v-model="prog.main_info.facility" disabled="true">
                  </div>
                </div>
                <div class="five wide field">
                  <label>Обеспечивающая кафедра</label>
                  <div class="ui input">
                    <input type="text" placeholder="Обеспечивающая кафедра" v-model="prog.main_info.department" disabled="true">
                  </div>
                </div>
                <div class="five wide field">
                  <label>
                    Заведующий кафедрой
                  </label>
                  <div class="ui input">
                    <input type="text" placeholder="Заведующий кафедрой" v-model="prog.main_info.dep_manager" disabled="true">
                  </div>
                </div>
              </div>
              <div class="two fields">
                <div class="four wide field">
                  <label>Дата заседания кафедры</label>
                  <div class="ui input">
                    <input type="text" placeholder="Дата заседания кафедры" v-model="prog.main_info.approval_date" disabled="true">
                  </div>
                </div>
                <div class="two wide field">
                  <label>Протокол №</label>
                  <div class="ui input">
                    <input type="text" placeholder="Протокол №" v-model="prog.main_info.protocol_num" disabled="true">
                  </div>
                </div>
              </div>
              <div><textarea rows="2" v-model="prog.main_info.basis"></textarea></div>
              <div class="two fields">
                <div class="four wide field">
                  <label>Дата утверждения приказа</label>
                  <div class="ui input">
                    <input type="text" placeholder="Дата утверждения приказа" v-model="prog.main_info.basis_date" disabled="true">
                  </div>
                </div>
                <div class="two wide field">
                  <label>№ Приказа</label>
                  <div class="ui input">
                    <input type="text" placeholder="№ Приказа" v-model="prog.main_info.basis_num" disabled="true">
                  </div>
                </div>
              </div>
              <h3 class="ui dividing header" v-if="prog.main_info.speciality_code.split('.')[1] !== '02'">1. ТИП ПРАКТИКИ И СПОСОБ ПРОВЕДЕНИЯ</h3>
              <div>
                <h4>1.1 Тип (форма проведения) практики</h4>
                <span v-html="prog.practice_type.type"></span>
                <h4 v-if="prog.main_info.speciality_code.split('.')[1] !== '02'">1.2 Способы проведения практики</h4>
                <span v-if="prog.main_info.speciality_code.split('.')[1] !== '02'" v-html="prog.practice_type.method"></span>
              </div>
              <h3 class="ui dividing header" v-if="prog.main_info.speciality_code.split('.')[1] !== '02'">2. ЦЕЛИ  И ЗАДАЧИ  ПРАКТИКИ</h3>
              <span v-if="prog.main_info.speciality_code.split('.')[1] !== '02'" v-html="prog.purpose_old"></span>
              <h3 class="ui dividing header">3. КОМПЕТЕНЦИИ ОБУЧАЮЩЕГОСЯ, ФОРМИРУЕМЫЕ В РЕЗУЛЬТАТЕ ОСВОЕНИЯ ДИСЦИПЛИНЫ (МОДУЛЯ) И ИНДИКАТОРЫ ИХ ДОСТИЖЕНИЯ</h3>
              <div v-if="prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7">
                <h4>3.1 Универсальные компетенции и индикаторы их достижения</h4>
                <table class="ui basic celled table">
                  <thead>
                  <tr class="active">
                    <th width="20%"><div class="headTable">Категория (группа) универсальных компетенций</div></th>
                    <th width="40%"><div class="headTable">Код и наименование универсальной компетенции</div></th>
                    <th width="40%"><div class="headTable">Код и наименование индикатора достижения универсальной компетенции</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "comp in prog.competition.UK">
                    <td>{{comp.info.cat}}</td>
                    <td>
                      {{ comp.info.code }} {{ comp.info.desc }}
                    </td>
                    <td v-html="comp.text"></td>
                  </tr>
                  </tbody>
                </table>
                <h4>3.2 Общепрофессиональные компетенции и индикаторы их достижения</h4>
                <table class="ui basic celled table" v-if="prog.competition.OPK_cat.length">
                  <thead>
                  <tr class="active">
                    <th width="20%"><div class="headTable">Категория (группа) общепрофессиональных компетенций</div></th>
                    <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
                    <th width="40%"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "comp in prog.competition.OPK_cat">
                    <td>{{comp.info.cat}}</td>
                    <td>
                      {{ comp.info.code }} {{ comp.info.desc }}
                    </td>
                    <td v-html="comp.text"></td>
                  </tr>
                  </tbody>
                </table>
                <table class="ui basic celled table" v-if="prog.competition.OPK.length">
                  <thead>
                  <tr class="active">
                    <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
                    <th width="60%"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "comp in prog.competition.OPK">
                    <td>{{comp.name}}</td>
                    <td v-html="comp.text"></td>
                  </tr>
                  </tbody>
                </table>
                <h4>3.3 Профессиональные компетенции и индикаторы их достижения</h4>
                <table class="ui basic celled table">
                  <thead>
                  <tr class="active">
                    <th width="40%"><div class="headTable">Код и наименование профессиональной компетенции</div></th>
                    <th width="60%"><div class="headTable">Код и наименование индикатора достижения профессиональной компетенции</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "comp in prog.competition.PK">
                    <td>{{comp.name}}</td>
                    <td v-html="comp.text"></td>
                  </tr>
                  </tbody>
                </table>
                <h4>3.4 Дополнительные профессиональные компетенции</h4>
                <table class="ui basic celled table">
                  <thead>
                  <tr class="active">
                    <th width="40%"><div class="headTable">Код и наименование дополнительной профессиональной компетенции</div></th>
                    <th width="60%"><div class="headTable">Код и наименование индикатора достижения дополнительной профессиональной компетенции</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "comp in prog.competition.DPK">
                    <td>{{comp.name}}</td>
                    <td v-html="comp.text"></td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div v-else>
                <h5 class="ui dividing header">Уметь </h5>
                <span v-html="prog.competition.able"></span>
                <h5 class="ui dividing header">Знать </h5>
                <span v-html="prog.competition.know"></span>
                <h5 class="ui dividing header">Владеть </h5>
                <span v-html="prog.competition.own"></span>
              </div>
              <h3 class="ui dividing header">4. МЕСТО ПРАКТИКИ В СТРУКТУРЕ ОБРАЗОВЕТЛЬНОЙ ПРОГРАММЫ </h3>
              <span v-html="prog.practice_place_old"></span>
              <h3 class="ui dividing header">5. МЕСТО И ВРЕМЯ ПРОВЕДЕНИЯ  ПРАКТИКИ </h3>
              <span v-html="prog.practice_time_old"></span>
              <h3 class="ui dividing header">6. ОБЪЕМ ПРАКТИКИ В ЗАЧЕТНЫХ ЕДИНИЦАХ И ЕЕ ПРОДОЛЖИТЕЛЬНОСТЬ В НЕДЕЛЯХ</h3>
              <span v-html="prog.practice_size_old"></span>
              <h3 class="ui dividing header">7. СТРУКТУРА И СОДЕРЖАНИЕ ПРАКТИКИ</h3>
              <table class="ui basic celled table">
                <thead>
                <tr class="active">
                  <th width="5%"><div class="headTable">№ п/п</div></th>
                  <th width="30%"><div class="headTable">Разделы (этапы) практики </div></th>
                  <th width="50%"><div class="headTable">Содержание раздела (этапа) практики</div></th>
                  <th width="5%"><div class="headTable">Трудоемкость (в академических часах)</div></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for = "work in prog.structure">
                  <td>{{prog.structure.indexOf(work) + 1}}</td>
                  <td>{{ work.part }}</td>
                  <td v-html="work.content"></td>
                  <td>{{ work.time }}</td>
                </tr>
                <tr>
                  <td></td>
                  <td colspan="2">Итого</td>
                  <td colspan="2">{{prog.main_info.load.hour}}</td>
                </tr>
                </tbody>
              </table>
              <h3 class="ui dividing header">8. ОБРАЗОВАТЕЛЬНЫЕ, НАУЧНО-ИССЛЕДОВАТЕЛЬСКИЕ И НАУЧНО-ПРОИЗВОДСТВЕННЫЕ ТЕХНОЛОГИИ, ИСПОЛЬЗУЕМЫЕ НА ПРАКТИКЕ</h3>
              <span v-html="prog.edu_tech_old"></span>
              <h3 class="ui dividing header">9. ФОРМА ОТЧЕТНОСТИ ПО ПРАКТИКЕ</h3>
              <span v-html="prog.report_text_old"></span>
              <div v-if="prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7">
                <h3 class="ui dividing header">10. ОЦЕНОЧНЫЕ СРЕДСТВА ДЛЯ ПРОВЕДЕНИЯ ПРОМЕЖУТОЧНОЙ АТТЕСТАЦИИ ПО ПРАКТИКЕ</h3>
                <span v-html="prog.eval_tool_old"></span>
              </div>
              <h3 class="ui dividing header">11. УЧЕБНО-МЕТОДИЧЕСКИЕ МАТЕРИАЛЫ ПО ПРАКТИКЕ</h3>
              <div>
                <h4>11.1. Литература</h4>
                <span v-html="prog.literature_old"></span>
                <h4>11.2. Программное обеспечение и Интернет-ресурсы</h4>
                <table class="ui basic celled table">
                  <thead>
                  <tr class="active">
                    <th width="20%"><div class="headTable">Наименование</div></th>
                    <th width="40%"><div class="headTable">Описание</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "soft in prog.software">
                    <td>
                      {{soft.info.name}}
                    </td>
                    <td>
                      {{ soft.info.license }}
                    </td>
                  </tr>
                  <tr v-for = "res in prog.resources">
                    <td>{{res.name}}</td>
                    <td>{{res.desc}}</td>
                  </tr>
                  </tbody>
                </table>
                <h4>11.3. Профессиональные базы данных и информационные справочные системы</h4>
                <table class="ui basic celled table">
                  <thead>
                  <tr class="active">
                    <th width="20%"><div class="headTable">Наименование</div></th>
                    <th width="40%"><div class="headTable">Описание</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "db in prog.data_bases">
                    <td>{{db.name}}</td>
                    <td>{{db.desc}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <h3 class="ui dividing header">12. ИНФОРМАЦИОННЫЕ ТЕХНОЛОГИИ, ИСПОЛЬЗУЕМЫЕ ДЛЯ ПРОВЕДЕНИЯ  ПРАКТИКИ</h3>
              <span v-html="prog.inform_tech_old"></span>
              <h3 class="ui dividing header">13. МАТЕРИАЛЬНО-ТЕХНИЧЕСКОЕ ОБЕСПЕЧЕНИЕ  ПРАКТИКИ </h3>
              <span v-html="prog.structure_text_old"></span>
              <div class="ui fitted divider"></div>
              <div>
                <button class="ui button negative" v-on:click="denyRPP(prog.id, rpp.indexOf(prog), prog.umu_agreed_times, prog.umu_comment)">
                  Отклонить
                </button>
                <button class="ui right floated button positive" v-on:click="agreedRPP(prog.id, rpp.indexOf(prog))">
                  Согласовать
                </button>
                <button class="ui right floated button blue" v-on:click="showRPP(prog.id)">
                  Просмотр
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="app_umu_rpp">
        <tiny-pagination
            :showLimit = false
            :total="currentTotal"
            @tiny:change-page="changePageRPP" />
      </div>
    </div>
    <div class="ui bottom attached tab segment " data-tab="rpg_umu">
      <div class="ui styled fluid accordion" >
        <div v-for="prog in rpg">
          <div class="title">
            <tr>
              <td width="1%">
                <i class="dropdown icon"></i>
              </td>
              <td width="35%">
                {{ prog.name }}
              </td>
              <td width="35%">
                {{ prog.main_info.speciality }}
              </td>
              <td width="15%">
                {{ prog.main_info.creator.fio }}
              </td>
              <td width="8%">
                {{ prog.main_info.year }}
              </td>
              <td width="6%">
                <a v-bind:href="'/programms/rpg/' + prog.id">Ссылка</a>
              </td>
            </tr>
          </div>
          <div class="content">
            <tr>
              <td width="15%"><h4>Отправленно на согласование</h4></td>
              <td width="10%">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
              <td width="25%">
                <h4>
                  Отправлено {{prog.umu_agreed_times}} раз
                </h4>
              </td>
            </tr>
            <div class="ui fitted divider"></div>
            <div class="ui form">
              <div class="inline fields">
                <div class="seven wide field" v-if="prog.main_info.speciality_code.split('.')[1] !== '05'">
                  <div class="ui right pointing large label">
                    Направление подготовки
                  </div>
                  <input type="text" placeholder="Специальность" v-model="prog.main_info.speciality" disabled="true">
                </div>
                <div class="seven wide field" v-if="prog.main_info.speciality_code.split('.')[1] === '05'">
                  <div class="ui right pointing large label">
                    Специальность
                  </div>
                  <input type="text" placeholder="Специальность" v-model="prog.main_info.speciality" disabled="true">
                </div>
                <div class="four wide field">
                  <div class="ui right pointing large label">
                    Квалификация выпускника
                  </div>
                  <input type="text" placeholder="Квалификация" v-model="prog.main_info.quality" disabled="true">
                </div>
              </div>
              <div class="inline fields">
                <div class="seven wide field" v-if="prog.main_info.speciality_code.split('.')[1] !== '05'">
                  <div class="ui right pointing large label">
                    Профиль
                  </div>
                  <input type="text" placeholder="Профиль" v-model="prog.main_info.profile" disabled="true">
                </div>
                <div class="seven wide field" v-if="prog.main_info.speciality_code.split('.')[1] === '05'">
                  <div class="ui right pointing large label">
                    Специализация
                  </div>
                  <input type="text" placeholder="Профиль" v-model="prog.main_info.profile" disabled="true">
                </div>
                <div class="two wide field">
                  <div class="ui right pointing large label">
                    Год набора
                  </div>
                  <input type="text" placeholder="Год набора" v-model="prog.main_info.year" disabled="true">
                </div>
                <div class="three wide field">
                  <div class="ui right pointing large label">
                    Форма обучения
                  </div>
                  <input type="text" placeholder="Форма обучения" v-model="prog.main_info.edu_form" disabled="true">
                </div>
              </div>
              <div class="ui equal width form">
                <div class="inline fields">
                  <div class="four wide field">
                    <div class="ui right pointing large label">
                      И.О.Фамилия
                    </div>
                    <input type="text" placeholder="И.О.Фамилия" v-model="prog.main_info.creator.fio" disabled="true">
                  </div>
                  <div class="four wide field">
                    <div class="ui right pointing large label">
                      Должность
                    </div>
                    <input type="text" placeholder="Должность" v-model="prog.main_info.creator.position" disabled="true">
                  </div>
                  <div class="four wide field">
                    <div class="ui right pointing large label">
                      Ученая степень
                    </div>
                    <input type="text" placeholder="Ученая степень" v-model="prog.main_info.creator.title" disabled="true">
                  </div>
                </div>
              </div>
              <div class="two fields">
                <div class="six wide field">
                  <label>Выпускающая кафедра</label>
                  <div class="ui input">
                    <input type="text" placeholder="Выпускающая кафедра" v-model="prog.main_info.grad_dep" disabled="true">
                  </div>
                </div>
                <div class="six wide field">
                  <label>Заведующий выпускающей кафедры</label>
                  <div class="ui input">
                    <input type="text" placeholder="Заведующий выпускающей кафедры" v-model="prog.main_info.provisor" disabled="true">
                  </div>
                </div>
              </div>
              <div class="three fields">
                <div class="five wide field">
                  <label>Факультет</label>
                  <div class="ui input">
                    <input type="text" placeholder="Факультет" v-model="prog.main_info.facility" disabled="true">
                  </div>
                </div>
                <div class="five wide field">
                  <label>Обеспечивающая кафедра</label>
                  <div class="ui input">
                    <input type="text" placeholder="Обеспечивающая кафедра" v-model="prog.main_info.department" disabled="true">
                  </div>
                </div>
                <div class="five wide field">
                  <label>
                    Заведующий кафедрой
                  </label>
                  <div class="ui input">
                    <input type="text" placeholder="Заведующий кафедрой" v-model="prog.main_info.dep_manager" disabled="true">
                  </div>
                </div>
              </div>
              <div class="two fields">
                <div class="four wide field">
                  <label>Дата заседания кафедры</label>
                  <div class="ui input">
                    <input type="text" placeholder="Дата заседания кафедры" v-model="prog.main_info.approval_date" disabled="true">
                  </div>
                </div>
                <div class="two wide field">
                  <label>Протокол №</label>
                  <div class="ui input">
                    <input type="text" placeholder="Протокол №" v-model="prog.main_info.protocol_num" disabled="true">
                  </div>
                </div>
              </div>
              <div><textarea rows="2" v-model="prog.main_info.basis" disabled="true"></textarea></div>
              <div class="two fields">
                <div class="four wide field">
                  <label>Дата утверждения приказа</label>
                  <div class="ui input">
                    <input type="text" placeholder="Дата утверждения приказа" v-model="prog.main_info.basis_date" disabled="true">
                  </div>
                </div>
                <div class="two wide field">
                  <label>№ Приказа</label>
                  <div class="ui input">
                    <input type="text" placeholder="№ Приказа" v-model="prog.main_info.basis_num" disabled="true">
                  </div>
                </div>
              </div>
              <h3 class="ui dividing header">1 Общие положения</h3>
              <textarea v-model="prog.active_type.actives" disabled="true" rows="30"></textarea>
              <h3 class="ui dividing header">2 Нормативные документы </h3>
              <textarea v-model="prog.active_type.tasks" disabled="true" rows="10"></textarea>
              <h3 class="ui dividing header">3 Объем выполнения научных исследований</h3>
              <div>
                Научные исследования аспиранта – это самостоятельная работа, ориентированная на  получение индивидуального научного результата
              </div>
              <div>
                Объем научных исследований аспиранта определяется учебным планом на весь периода  обучения:
              </div>
              <div class="inline fields">
                <div class="nine wide field">
                  Общая трудоемкость выполнения научных исследований составляет
                </div>
                <div  class="one wide">
                  <input type="text" placeholder="Зачетных едениц" v-model="prog.main_info.zet" disabled="true">
                </div>
                <div class="three wide field">
                  зачетных единиц
                </div>
                <div class="one wide">
                  <input type="text" placeholder="Академ часов" v-model="prog.main_info.hour" disabled="true">
                </div>
                <div class="two wide field">
                  (ак.ч.)
                </div>
              </div>
              <h3 class="ui dividing header">4 Этапы выполнения научных исследований</h3>
              <table class="ui basic celled table">
                <thead>
                <tr class="active">
                  <th width="10%"><div class="headTable">Этапы</div></th>
                  <th width="50%"><div class="headTable">Перечень работ по этапам </div></th>
                  <th width="10%"><div class="headTable">Курс</div></th>
                  <th width="30%"><div class="headTable">Форма</div></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for = "dis in prog.discipline">
                  <td colspan="4">
                    <table class="ui basic celled table">
                      <thead>
                      <tr class="active">
                        <th colspan="4" width="5%">{{ dis.name }}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for = "work in dis.work">
                        <td width="10%">{{ work.stage }}</td>
                        <td width="50%" v-html="work.content"></td>
                        <td width="10%">{{ work.course }}</td>
                        <td width="30%">{{ work.control }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                </tbody>
              </table>
              <h3 class="ui dividing header">5 Текущий контроль и промежуточная аттестация по этапам выполнения научного исследования</h3>
              <span v-html="prog.structure_old"></span>
              <h3>6 Учебно-методическое и информационное обеспечение выполнения плана научной деятельности</h3>
              <div>
                <h4>1 Рекомендуемая литература</h4>
                <span v-html="prog.literature_old"></span>
                <h5>2 Программное обеспечение и Интернет-ресурсы</h5>
                <h5>Программное обеспечение</h5>
                <table class="ui basic celled table">
                  <thead>
                  <tr class="active">
                    <th width="20%"><div class="headTable">Наименование</div></th>
                    <th width="40%"><div class="headTable">Описание</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "soft in prog.software">
                    <td>
                      {{soft.info.name}}
                    </td>
                    <td>
                      {{ soft.info.license }}
                    </td>
                  </tr>
                  <tr v-for = "res in prog.resources">
                    <td>{{res.name}}</td>
                    <td>{{res.desc}}</td>
                  </tr>
                  </tbody>
                </table>
                <h4>3 Профессиональные базы данных и информационные справочные системы</h4>
                <table class="ui basic celled table">
                  <thead>
                  <tr class="active">
                    <th width="20%"><div class="headTable">Наименование</div></th>
                    <th width="40%"><div class="headTable">Описание</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "db in prog.data_bases">
                    <td>{{db.name}}</td>
                    <td>{{db.desc}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <h3>7 Материально-техническое обеспечение выполнения плана научной деятельности</h3>
              <span v-html="prog.subject_old"></span>
              <div class="ui fitted divider"></div>
              <div>
                <button class="ui button negative" v-on:click="denyRPG(prog.id, rpg.indexOf(prog), prog.umu_agreed_times, prog.umu_comment)">
                  Отклонить
                </button>
                <button class="ui right floated button positive" v-on:click="agreedRPG(prog.id, rpg.indexOf(prog))">
                  Согласовать
                </button>
                <button class="ui right floated button blue" v-on:click="showRPG(prog.id)">
                  Просмотр
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui modal" id="deny_umu_modal">
      <div class="ui header">Отклонить?</div>
      <div class="content">
        <div class="ui form">
          <div class="field">
            <label>Оставить отзыв (опционально)</label>
            <textarea v-model="deny_text"></textarea>
          </div>
        </div>
      </div>
      <div class="actions">
        <div class="ui gray deny button">
          Закрыть
        </div>
        <div class="ui positive inverted right labeled icon button">
          Подтвердить
          <i class="checkmark icon"></i>
        </div>
      </div>
    </div>
    <div class="ui modal" id="error_umu_modal">
      <div class="ui header">Произошла ошибка</div>
      <div class="content">
        <div class="ui form">
          <div class="field">
            <label v-model="error_message_text"></label>
          </div>
        </div>
      </div>
      <div class="actions">
        <div class="ui gray deny button">
          Закрыть
        </div>
        <div class="ui positive inverted right labeled icon button">
          Подтвердить
          <i class="checkmark icon"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { TinyPagination } from 'vue-tiny-pagination';
import DashboardIndex from "../../../v2/dashboard/dashboard_index";

export default {
  name: "umu_agreed_rpd",
  components: {
    DashboardIndex,
    TinyPagination,
  },
  data: () => ({
    rpd: [],
    rpp: [],
    rpg: [],
    deny_text: "",
    currentTotal: 100,
    currentPageRPD: 1,
    currentPageRPP: 1,
    error_message_text: "",
    level: 1,
  }),
  methods: {
    getRPDs(currentPageRPD, level) {
      axios({
        method: 'get',
        url: `/programms/umu_agreed/${level}/${currentPageRPD}`
      }).then((response) => {
        this.rpd = response.data.rpd
        this.rpd.sort(function (a, b) {
          return a.id - b.id;
        });
      }).catch((error) => {
        return error;
      });
    },
    denyRPD(id, index, times, text){
      this.deny_text = text;
      $('#deny_umu_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          const token = document.querySelector('[name=csrf-token]').content;
          axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
          axios({
            method: 'put',
            url: '/programms/rpd/' + id,
            data: {
              data: {
                umu_agreed: false,
                umu_comment: this.deny_text,
                umu_agreed_times: times + 1,
                considered: false,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204){
              this.rpd.splice(index, 1)
              if (!this.rpd.length){
                this.getRPDs(this.currentPageRPD)
              }
            } else{
              $('#error_umu_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
            $('#error_umu_modal').modal({
              closable: false,
              autofocus: false,
              onDeny: () => {
              },
              onApprove: () => {
              }
            }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    agreedRPD(id, index){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'put',
        url: '/programms/rpd/' + id,
        data: {
          data: {
            umu_agreed: true,
          }
        }
      }).then((response) => {
        if(response.status == 200 || response.status == 204){
          this.rpd.splice(index, 1)
          if (!this.rpd.length){
            this.getRPDs(this.currentPageRPD)
          }
        } else{
          $('#error_umu_modal').modal({
            closable: false,
            autofocus: false,
            onDeny: () => {
            },
            onApprove: () => {
            }
          }).modal('show');
        }
      }).catch((error) => {
        this.error_message_text = error.response.data,
            $('#error_umu_modal').modal({
              closable: false,
              autofocus: false,
              onDeny: () => {
              },
              onApprove: () => {
              }
            }).modal('show');
        return error;
      });
    },
    showRPD(id){
      location.assign(`/programms/rpd/${id}`)
    },
    changePageRPD(pagination) {
      this.currentPageRPD = pagination.page;
      this.getRPDs(this.currentPageRPD)
    },
    getRPPs(currentPageRPP, level) {
      axios({
        method: 'get',
        url: `/programms/umu_agreed_rpp/${level}/${currentPageRPP}`
      }).then((response) => {
        this.rpp = response.data.rpp
        this.rpp.sort(function (a, b) {
          return a.id - b.id;
        });
      }).catch((error) => {
        return error;
      });
    },
    denyRPP(id, index, times, text){
      this.deny_text = text;
      $('#deny_umu_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          const token = document.querySelector('[name=csrf-token]').content;
          axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
          axios({
            method: 'put',
            url: '/programms/rpp/' + id,
            data: {
              data: {
                umu_agreed: false,
                umu_comment: this.deny_text,
                umu_agreed_times: times + 1,
                considered: false,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204){
              this.rpp.splice(index, 1)
              if (!this.rpp.length){
                this.getRPPs(this.currentPageRPP)
              }
            } else{
              $('#error_umu_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_umu_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    agreedRPP(id, index){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'put',
        url: '/programms/rpp/' + id,
        data: {
          data: {
            umu_agreed: true,
          }
        }
      }).then((response) => {
        if(response.status == 200 || response.status == 204){
          this.rpp.splice(index, 1)
          if (!this.rpp.length){
            this.getRPPs(this.currentPageRPP)
          }
        } else{
          $('#error_umu_modal').modal({
            closable: false,
            autofocus: false,
            onDeny: () => {
            },
            onApprove: () => {
            }
          }).modal('show');
        }
      }).catch((error) => {
        this.error_message_text = error.response.data,
            $('#error_umu_modal').modal({
              closable: false,
              autofocus: false,
              onDeny: () => {
              },
              onApprove: () => {
              }
            }).modal('show');
        return error;
      });
    },
    showRPP(id){
      location.assign(`/programms/rpp/${id}`)
    },
    changePageRPP(pagination) {
      this.currentPageRPP = pagination.page;
      this.getRPPs(this.currentPageRPP)
    },
    getRPGs() {
      axios({
        method: 'get',
        url: `/programms/umu_agreed_rpg`
      }).then((response) => {
        this.rpg = response.data.rpg
        this.rpg.sort(function (a, b) {
          return a.id - b.id;
        });
      }).catch((error) => {
        return error;
      });
    },
    denyRPG(id, index, times, text){
      this.deny_text = text;
      $('#deny_umu_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          const token = document.querySelector('[name=csrf-token]').content;
          axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
          axios({
            method: 'put',
            url: '/programms/rpg/' + id,
            data: {
              data: {
                umu_agreed: false,
                umu_comment: this.deny_text,
                umu_agreed_times: times + 1,
                considered: false,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204){
              this.rpg.splice(index, 1)
            } else{
              $('#error_umu_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_umu_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    agreedRPG(id, index){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'put',
        url: '/programms/rpg/' + id,
        data: {
          data: {
            umu_agreed: true,
          }
        }
      }).then((response) => {
        if(response.status == 200 || response.status == 204){
          this.rpg.splice(index, 1)
        } else{
          $('#error_umu_modal').modal({
            closable: false,
            autofocus: false,
            onDeny: () => {
            },
            onApprove: () => {
            }
          }).modal('show');
        }
      }).catch((error) => {
        this.error_message_text = error.response.data,
            $('#error_umu_modal').modal({
              closable: false,
              autofocus: false,
              onDeny: () => {
              },
              onApprove: () => {
              }
            }).modal('show');
        return error;
      });
    },
    showRPG(id){
      location.assign(`/programms/rpg/${id}`)
    },
  },
  mounted() {
    this.getRPPs(this.currentPageRPP)
  }
}
</script>

<style scoped>

</style>